<form [formGroup]="form">

  <mat-tab-group class="tabs">

    <mat-tab label="Media">
      <div class="wrap">
        <div class="d-flex flex-wrap">
          <div class="flex-fill p-3 bg-light border border-end-0">
            <mat-card class="card">
              <div class="card-title">
                <i class="fab fa-whatsapp whatsapp-icon"></i>
                <span>WhatsApp</span>
              </div>

              <div>
                <span class="d-flex"><b>WhatsApp Number: </b></span>
              </div>
              <mat-form-field appearance="outline" class="wa-number">
                <mat-label>WhatsApp Number</mat-label>
                <input matInput placeholder="+14165551234" formControlName="waNumber" type="tel" inputmode="tel"
                  maxlength="16" />
                <mat-icon matSuffix matTooltip="numbers only">info</mat-icon>
              </mat-form-field>
            </mat-card>
          </div>
          <!-- <div class="flex-fill p-3 bg-light border border-start-0">
            <mat-card class="preview">
              <span class="d-flex mt-2"><b>Greeting Message (optional) : </b></span>

              <mat-form-field appearance="outline" class="w-100 multiline-select mt-4">
                <mat-label>Click to chat : WhatsApp / SMS</mat-label>
                <mat-select formControlName="waMessage" panelClass="wa-panel"
                  (selectionChange)="onSelectionChange($event)">
                  <mat-option *ngFor="let message of filteredMessages" [value]="message">
                    <span class="option-text">{{ message }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-card>
          </div> -->

        </div>
        <div class="actions mt-5 mr-2">
          <button mat-stroked-button color="primary" type="button" (click)="onCancel()">Cancel</button>
          <!-- <button mat-flat-button color="primary" type="button" (click)="saveAll()">
            Save
          </button> -->
         <button
  mat-flat-button
  color="primary"
  type="button"
  (click)="saveAll()"
  [disabled]="!hasRealChanges() || saving"
>
  Save
</button>
        </div>
        <div>

          <div class="card-title mt-2">
            <mat-icon>public</mat-icon>
            <div class="mb-2"><span>Links</span></div>
          </div>

          <div class="table-wrap">
            <mat-table [dataSource]="socialRows" class="mat-elevation-z8 social-table">
              <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let r">
                  <ng-container *ngIf="r.fa; else imgIcon">
                    <i class="sm-icon" [ngClass]="r.fa" aria-hidden="true"></i>
                  </ng-container>
                  <ng-template #imgIcon>
                    <img *ngIf="r.img" class="sm-icon sm-img" [src]="r.img" alt="" />
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef>URL</th>
                <td mat-cell *matCellDef="let r">
                  <mat-form-field appearance="outline" class="sm-field dense">
                    <mat-label>{{ r.placeholder }}</mat-label>
                    <input matInput [formControlName]="r.controlName" [placeholder]="r.placeholder"
                      [readonly]="!editing[r.controlName]" />
                  </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-end">Action</th>
                <td mat-cell *matCellDef="let r" class="text-end">
                  <div class="sm-actions social-button">
                    <button mat-stroked-button color="primary" class="btn-compact" (click)="onSave(r)"
                      [disabled]="!editing[r.controlName]">
                      Save
                    </button>
                    <button mat-icon-button class="action-icon edit" matTooltip="Edit" (click)="onEdit(r.controlName)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button class="action-icon delete" matTooltip="Delete"
                      (click)="onDelete(r.controlName)" [disabled]="loading[r.controlName]">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <!-- <button mat-icon-button class="action-icon" matTooltip="Cancel" *ngIf="editing[r.controlName]"
                      (click)="onCancel(r.controlName)">
                      <mat-icon>close</mat-icon>
                    </button> -->
                  </div>
                </td>
              </ng-container>


              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
          </div>



        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</form>